import { useBranding } from '../../context/branding';

/**
 * The navbar's mark: the operator's logo, with the product's name beside it
 * when the superadmin turned that on. Without a logo, a drawn placeholder and
 * the product's name.
 */
export function BrandMark({ size = 26 }: { size?: number }) {
  const { brandName, appName, logo, showName } = useBranding();
  if (logo) {
    return (
      <span className="brand">
        <img className="brand-img" src={logo} alt={brandName} height={size} />
        {showName && <span className="brand-name">{appName}</span>}
      </span>
    );
  }

  return (
    <span className="brand">
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
        <path
          d="M16 2.5c5.2 6 9 10.6 9 15.2A9 9 0 0 1 7 17.7c0-4.6 3.8-9.2 9-15.2Z"
          fill="var(--brand)"
        />
        <path
          d="M16 8.6c2.9 3.5 4.8 6 4.8 8.6a4.8 4.8 0 0 1-9.6 0c0-2.6 1.9-5.1 4.8-8.6Z"
          fill="#fff"
          opacity="0.85"
        />
      </svg>
      <span className="brand-name">{appName}</span>
    </span>
  );
}
